module.exports = __webpack_public_path__ + "static/media/landing-vidal.ba5a0767.jpg";